import { Mail, Phone, MapPin, Clock } from "lucide-react";
import Seo from "../components/site/Seo";
import { PageHero, Section } from "../components/site/Bits";
import DynamicForm from "../components/forms/DynamicForm";
import { useSite, telHref } from "../lib/site";

export default function Contact() {
  const { settings: s } = useSite();
  const tel = telHref(s.phone);
  const rows = [
    { icon: Mail, label: "Email", value: <a href={`mailto:${s.public_email}`} className="font-semibold text-teal underline" data-testid="contact-email">{s.public_email}</a> },
    { icon: Phone, label: "Phone", value: tel ? <a href={tel} className="font-semibold text-teal underline">{s.phone}</a> : s.phone },
    { icon: MapPin, label: "Service area", value: s.service_area },
    { icon: Clock, label: "Business hours", value: s.hours },
  ];
  return (
    <>
      <Seo title="Contact Us" path="/contact" description="Contact Accessible Trials & Mods about NDIS equipment trials and home modifications in Melbourne and Victoria." />
      <PageHero eyebrow="Contact" title="Get in touch" intro="Send us a message, email or call. We're happy to talk through your options, with no obligation." />
      <Section>
        <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr]">
          <ul className="space-y-4" aria-label="Contact details">
            {rows.map((r) => (
              <li key={r.label} className="card flex gap-4 p-5">
                <r.icon className="mt-1 shrink-0 text-teal" size={24} aria-hidden="true" />
                <div><p className="font-semibold">{r.label}</p><div className="break-words text-ink-muted">{r.value}</div></div>
              </li>
            ))}
            {s.address && <li className="card p-5"><p className="font-semibold">Address</p><p className="text-ink-muted">{s.address}</p></li>}
          </ul>
          <div><h2 className="mb-6 font-display text-3xl font-semibold">Send us a message</h2><DynamicForm kind="contact" testid="contact-form" /></div>
        </div>
      </Section>
    </>
  );
}
